// extracted by mini-css-extract-plugin
module.exports = {"promoCodeButton":"PromotionInput_promoCodeButton__TDVIK","promoCodeInputBox":"PromotionInput_promoCodeInputBox__Q2SiC","promoCodeForm":"PromotionInput_promoCodeForm__kISEb"};